const screenConfigurationTemplate = {
  key: null,
  label: null,
  description: null,
  message: null,
  submessage: null,
  icons: null,
  graphicsStyle: null,
};

export default {
  modal_welcome: {
    ...screenConfigurationTemplate,
    key: 'modal_welcome',
    label: 'Ekran powitania w godzinach dostępności',
    message: {
      title: 'Tytuł ekranu',
    },
  },
  modal_welcome_after_hours: {
    ...screenConfigurationTemplate,
    key: 'modal_welcome_after_hours',
    label: 'Ekran powitania po godzinach dostępności',
    message: {
      title: 'Tytuł ekranu',
    },
  },
  virtual_departments: {
    ...screenConfigurationTemplate,
    key: 'virtual_departments',
    label: 'Ekran, wyboru Wirtulanego Działu, w przypadku połączenia do Wirtualnych Działów',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
  calling: {
    ...screenConfigurationTemplate,
    key: 'calling',
    label: 'Ekran, gdy system dzwoni do użytkownika',
    message: {
      title: 'Tytuł ekranu',
    },
    graphicsStyle: true,
  },
  pick_up: {
    ...screenConfigurationTemplate,
    key: 'pick_up',
    label: 'Ekran odebrania połączenia',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
    icons: true,
  },
  waiting_in_queue: {
    ...screenConfigurationTemplate,
    key: 'waiting_in_queue',
    label: 'Ekran oczekiwania w kolejce',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
    icons: true,
  },
  connecting: {
    ...screenConfigurationTemplate,
    key: 'connecting',
    label: 'Ekran oczekiwania na połączenie z Konsultantem',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
    icons: true,
  },
  talking: {
    ...screenConfigurationTemplate,
    key: 'talking',
    label: 'Ekran rozmowy z Konsultantem',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
    icons: true,
  },
  call_end: {
    ...screenConfigurationTemplate,
    key: 'call_end',
    label: 'Ekran po rozłączeniu połączenia',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
  missed_call: {
    ...screenConfigurationTemplate,
    key: 'missed_call',
    label: 'Ekran zakończenia połączenia w przypadku zajętości wszystkich Kontultantów',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
  choose_date_and_time: {
    ...screenConfigurationTemplate,
    key: 'choose_date_and_time',
    label: 'Ekran zamówienia połączenia',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
  leave_message: {
    ...screenConfigurationTemplate,
    key: 'leave_message',
    label: 'Ekran pozostawienia wiadomości',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
  after_callback: {
    ...screenConfigurationTemplate,
    key: 'after_callback',
    label: 'Ekran podziękowania za pozostawienie wiadomości lub zamówienie połączenia',
    message: {
      title: 'Tytuł ekranu',
    },
    submessage: {
      title: 'Treść dodatkowa',
    },
  },
};
